/* Shared password helpers used by ChangeTemporaryPassword, AccountSettings,
 * and ResetPassword pages. Keeps validation in sync with the backend rules
 * implemented in server.py: validate_password_strength(). */

export const PASSWORD_MIN_LEN = 8;

export function validateNewPassword(next, confirm) {
  if (!next || next !== next.trim()) {
    return `Password must be at least ${PASSWORD_MIN_LEN} characters and contain no leading or trailing spaces.`;
  }
  if (next.length < PASSWORD_MIN_LEN) {
    return `Password must be at least ${PASSWORD_MIN_LEN} characters.`;
  }
  if (!/[A-Za-z]/.test(next) || !/\d/.test(next)) {
    return "Password must contain at least one letter and one digit.";
  }
  if (confirm !== undefined && next !== confirm) {
    return "New password and confirmation do not match.";
  }
  return null;
}
